<script setup>
/******************************************************************************
 * Component: global error messages at the bottom
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
defineProps({
    top: {
        type: Number,
        default: 0,
    },
    bottom: {
        type: Number,
        default: 0,
    },
    errorText: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div class="error">
        <header>
            <svg-icon name="error" />
            <h1>Fehler</h1>
        </header>
        {{ errorText }}
    </div>
</template>

<style lang="scss" scoped>
.error {
    padding: #{get($sizes, "base") * 0.5};
    border: get($sizes, "border") solid palette("state", "error");
    margin-top: calc(v-bind(top) * get($sizes, "base"));
    margin-bottom: calc(v-bind(bottom) * get($sizes, "base"));

    background-color: color.adjust(palette("state", "error"), $lightness: +50%);
    color: color.adjust(palette("state", "error"), $lightness: -15%);

    font-weight: 400;
    text-align: center;

    @include respond-to("medium") {
        margin-top: calc(v-bind(top) * get($sizes, "base") * 2);
        margin-bottom: calc(v-bind(bottom) * get($sizes, "base") * 2);
    }

    header {
        display: flex;
        align-items: center;
        justify-content: center;

        gap: get($sizes, "base");

        h1 {
            margin: 0;

            font-size: #{get($sizes, "base") * 1.25};
            font-weight: 500;
        }
    }
}
</style>
